import React, { Component } from "react";
import "./PowerSupplyControls.scss";

import PowerSupply from './img/powerSupply.svg'
import PowerSupply1 from './img/powerSupply1.svg'
import PowerSupply2 from './img/powerSupply2.svg'
import PowerSupply3 from './img/powerSupply3.svg'
import DownButton from './img/downButton.svg'
import UpButton from './img/upButton.svg'
import StartButton from './img/startButton.svg'
import StopButton from './img/stopButton.svg'
import PowerButton from './img/powerButton.svg'
import DownButtonHover from './img/downButtonHover.svg'
import UpButtonHover from './img/upButtonHover.svg'
import StartButtonHover from './img/startButtonHover.svg'
import StopButtonHover from './img/stopButtonHover.svg'
import PowerButtonHover from './img/powerButtonHover.svg'


const images = {
  powerSupply: PowerSupply,
  powerSupply1: PowerSupply1,
  powerSupply2: PowerSupply2,
  powerSupply3: PowerSupply3,
  downButton: DownButton,
  upButton: UpButton,
  startButton: StartButton,
  stopButton: StopButton,
  powerButton: PowerButton,
  downButtonHover: DownButtonHover,
  upButtonHover: UpButtonHover,
  startButtonHover: StartButtonHover,
  stopButtonHover: StopButtonHover,
  powerButtonHover: PowerButtonHover
}

export class PowerSupplyControls extends Component {
    constructor(props) {
        super(props);

        this.state = {
          scale: 1,
          pressed: false,
          fired: false,
          buttons: {
            powerSupply: false,
            timeDownButton: false,
            timeUpButton: false,
            ampDownButton: false,
            ampUpButton: false,
            wattDownButton: false,
            wattUpButton: false,
            voltageDownButton: false,
            voltageUpButton: false,
            startButton: false,
            stopButton: false,
            powerButton: false
          }
        }
    }

    incState = (e, comp) => {
      if((e.type === "mousedown" || e.type === "keydown") && !this.state.fired){
        this.setState({
          pressed: true,
          fired: true
        }, ()=>comp.call())
      }
      if (e.type === "mouseup" || e.type === "mouseout" || e.type === "keyup"){
        this.setState({
          pressed: false,
          fired: false
        }, ()=>comp.call())
      }
    }

    decState = (e, comp) => {
      if((e.type === "mousedown" || e.type === "keydown") && !this.state.fired){
        this.setState({
          pressed: true,
          fired: true
        }, ()=>comp.call())
      }
      if (e.type === "mouseup" || e.type === "mouseout" || e.type === "keyup"){
        this.setState({
          pressed: false,
          fired: false
        }, ()=>comp.call())
      }
    }

    incTime = () => {

      if(this.state.pressed){

        if(this.props.power){
          this.props.incPowerSupplyTime({id: this.props.id})
        }
        this.changeImage('timeUpButton')

        window.setTimeout(()=>this.incTime(), 100);
      }
    }
    incTimeRelease = () => {
      this.resetImage('timeUpButton')
    }

    decTime = () => {

      if(this.state.pressed){

        if(this.props.power){
          this.props.decPowerSupplyTime({id: this.props.id})
        }
        this.changeImage('timeDownButton')

        window.setTimeout(()=>this.decTime(), 100);
      }
    }
    decTimeRelease = () => {
      this.resetImage('timeDownButton')
    }


    incAmp = () => {

      if(this.state.pressed){

        if(this.props.power){
          this.props.incPowerSupplyAmp({id: this.props.id})
        }
        this.changeImage('ampUpButton')

        window.setTimeout(()=>this.incAmp(), 100);
      }
    }
    incAmpRelease = () => {
      this.resetImage('ampUpButton')
    }

    decAmp = () => {
      if(this.state.pressed){

        if(this.props.power){
          this.props.decPowerSupplyAmp({id: this.props.id})
        }
        this.changeImage('ampDownButton')

        window.setTimeout(()=>this.decAmp(), 100);
      }
    }
    decAmpRelease = () => {
      this.resetImage('ampDownButton')
    }

    incWatt = () => {

      if(this.state.pressed){

        if(this.props.power){
          this.props.incPowerSupplyWatt({id: this.props.id})
        }
        this.changeImage('wattUpButton')

        window.setTimeout(()=>this.incWatt(), 100);
      }
    }
    incWattRelease = () => {
      this.resetImage('wattUpButton')
    }

    decWatt = () => {
      if(this.state.pressed){

        if(this.props.power){
          this.props.decPowerSupplyWatt({id: this.props.id})
        }
        this.changeImage('wattDownButton')

        window.setTimeout(()=>this.decWatt(), 100);
      }
    }
    decWattRelease = () => {
      this.resetImage('wattDownButton')
    }

    incVoltage = () => {

      if(this.state.pressed){

        if(this.props.power){
          this.props.incPowerSupplyVoltage({id: this.props.id})
        }
        this.changeImage('voltageUpButton')

        window.setTimeout(()=>this.incVoltage(), 100);
      }
    }
    incVoltageRelease = () => {
      this.resetImage('voltageUpButton')
    }

    decVoltage = () => {
      if(this.state.pressed){

        if(this.props.power){
          this.props.decPowerSupplyVoltage({id: this.props.id})
        }
        this.changeImage('voltageDownButton')

        window.setTimeout(()=>this.decVoltage(), 100);
      }
    }
    decVoltageRelease = () => {
      this.resetImage('voltageDownButton')
    }

    powerButtonDown = () => {
      this.props.togglePowerSupplyPower( {power: !this.props.power, id: this.props.id,})
      this.changeImage('powerButton')
    }
    powerButtonRelease = () => {
      //this.props.incPowerSupplyVoltage({id: this.props.id})
      this.resetImage('powerButton')
    }
    startButtonDown = () => {
      this.props.togglePowerSupplyStart({active: true, id: this.props.id})
      this.changeImage('startButton')

      this.interval = setInterval(() => {
        if(this.props.power){
          this.props.countDownPowerSupplyTime({id: this.props.id, interval: 1})

          if(this.props.anodeConnected && this.props.cathodeConnected && this.props.gelbox.anodeConnected && this.props.gelbox.cathodeConnected && this.props.gelbox.solutionAlias !== null){
            this.props.setGelResult({id: 1, voltage: this.props.voltage, watts: this.props.watts, current: this.props.current})
          }
        }
        if(this.props.timer === 0 || !this.props.power){
          clearInterval(this.interval);
        }
      }, 10);
    }
    startButtonRelease = () => {
      this.resetImage('startButton')
    }
    stopButtonDown = () => {

      if(this.props.active){
        this.props.togglePowerSupplyStart({active: false, id: this.props.id})
        clearInterval(this.interval);
      } else {

        this.props.resetPowerSupplyTime()
      }

      this.changeImage('stopButton')
    }
    stopButtonRelease = () => {
      this.resetImage('stopButton')
    }

    changeImage = (btn) => {
      this.setState({
        buttons: {
         [btn]: true
        }
      });
    }

    resetImage = (btn) => {
      this.setState({
        buttons: {
         [btn]: false
        }
      });
    }

    formatTime = () => {

      let hours = Math.floor(this.props.timer/3600)
      let mins = Math.floor(this.props.timer/60)%60
      let secs = this.props.timer%60

      if(hours<10){
        hours = "0"+hours
      }

      if(mins<10){
          mins = "0"+mins
      }
      if(secs<10){
          secs = "0"+secs
      }

      return hours + " : " + mins + " : " + secs
    }

    handleResize = () => {

      let refSize = this.image.getBoundingClientRect();

      let scale = Math.min(
        (refSize.width) / 403,
        (refSize.height) / 359
      );

      this.setState({
        scale: scale
      })

    }
    // We need to attach a window event listener once the component is loaded in the DOM
    componentDidMount() {

      // Resize the scene and attach the resize method to the window resize event
      window.addEventListener("resize", this.handleResize)

    }
    componentWillUnmount(){

      window.removeEventListener("resize", this.handleResize)

    }
    componentDidUpdate(prevProps, prevState) {

      if(this.state.scale !== prevState.scale){
        this.handleResize()
      }
      if(this.props.display !== prevProps.display){
        this.handleResize()
      }
      if(this.props.notebookExpanded !== prevProps.notebookExpanded){
        this.handleResize()
      }


    }

    render() {
        return (
          <div style={{height: '100%'}}>
            <div className="modal-section">
              <div className="modal-header">
                  <h2 tabIndex="0">{'Adjust power supply controls'}</h2>
              </div>
              <div className="modal-body">
                <div id="powerSupplyModal" className="modal-inner">
                  <div className="power-supply-content">
                      <div className="power-supply">
                        <img
                          ref={(image)=> {this.image = image}}
                          onLoad={this.handleResize}
                          src={(this.props.anodeConnected)?(this.props.cathodeConnected)?images.powerSupply3: images.powerSupply1:(this.props.cathodeConnected)?images.powerSupply2:images.powerSupply}
                          alt="anodeConnected"
                          />
                      </div>
                      <div className="power-supply-values" style={{display: (this.props.power)?null:'none'}}>
                        <div style={{transform: "scale("+ this.state.scale +") translate(-50%, -50%)", width: "422px", height: "359px", transformOrigin: "0% 0%", position: "absolute", top: "50%", left: "50%"}}>
                          <div className="main-display">
                            <p className="voltage">{Math.round(this.props.voltage * 10) / 10+" V"}</p>
                          </div>
                          <div className="sub-display">
                            <p className="current">{"Current: "+Math.round(this.props.current * 100) / 100 + " A"}</p>
                            <p className="watts">{"Power: "+Math.round(this.props.watts * 100) / 100 + " W"}</p>
                            <p className="time">{"Time: "+this.formatTime()}</p>
                            <p className="time-abrv"><span style={{marginLeft: '6%'}}>HH</span><span style={{marginLeft: '9.5%'}}>MM</span><span style={{marginLeft: '6.5%'}}>SS</span></p>
                          </div>
                        </div>
                      </div>
                  </div>
                  <div className="power-supply-controls">
                    <div style={{transform: "scale("+ this.state.scale +") translate(-50%, -50%)", width: "422px", height: "359px", transformOrigin: "0% 0%", position: "absolute", top: "50%", left: "50%"}}>
                      <div className="time-control">
                        <button
                          onKeyDown={ (e)=>{if(e.which === 13 || e.which === 32) this.decState(e, this.decTime)} }
                          onKeyUp={ (e)=>{if(e.which === 13 || e.which === 32) this.decState(e, this.decTimeRelease)} }
                          onMouseDown={(e)=>{this.decState(e, this.decTime)}}
                          onMouseUp={(e)=>{this.decState(e, this.decTimeRelease)}}
                          onMouseOut={(e)=>{this.decState(e, this.decTimeRelease)}}>
                          <img
                            src={(this.state.buttons.timeDownButton)?images.downButtonHover:images.downButton}
                            alt="timeDownButton"
                            />
                        </button>
                        <button
                          onKeyDown={ (e)=>{if(e.which === 13 || e.which === 32) this.incState(e, this.incTime)} }
                          onKeyUp={ (e)=>{if(e.which === 13 || e.which === 32) this.incState(e, this.incTimeRelease)} }
                          onMouseDown={(e)=>{this.incState(e, this.incTime)}}
                          onMouseUp={(e)=>{this.incState(e, this.incTimeRelease)}}
                          onMouseOut={(e)=>{this.incState(e, this.incTimeRelease)}}>
                          <img
                            src={(this.state.buttons.timeUpButton)?images.upButtonHover:images.upButton}
                            alt="timeUpButton"
                            />
                        </button>
                      </div>
                      <div className="amp-control">
                        <button
                          onKeyDown={ (e)=>{if(e.which === 13 || e.which === 32) this.decState(e, this.decAmp)} }
                          onKeyUp={ (e)=>{if(e.which === 13 || e.which === 32) this.decState(e, this.decAmpRelease)} }
                          onMouseDown={(e)=>{this.decState(e, this.decAmp)}}
                          onMouseUp={(e)=>{this.decState(e, this.decAmpRelease)}}
                          onMouseOut={(e)=>{this.decState(e, this.decAmpRelease)}}>
                          <img
                            src={(this.state.buttons.ampDownButton)?images.downButtonHover:images.downButton}
                            alt="ampDownButton"
                            />
                        </button>
                        <button
                          onKeyDown={ (e)=>{if(e.which === 13 || e.which === 32) this.incState(e, this.incAmp)} }
                          onKeyUp={ (e)=>{if(e.which === 13 || e.which === 32) this.incState(e, this.incAmpRelease)} }
                          onMouseDown={(e)=>{this.incState(e, this.incAmp)}}
                          onMouseUp={(e)=>{this.incState(e, this.incAmpRelease)}}
                          onMouseOut={(e)=>{this.incState(e, this.incAmpRelease)}}>
                          <img
                            src={(this.state.buttons.ampUpButton)?images.upButtonHover:images.upButton} alt="ampUpButton" />
                        </button>
                      </div>
                      <div className="watt-control">
                        <button
                          onKeyDown={ (e)=>{if(e.which === 13 || e.which === 32) this.decState(e, this.decWatt)} }
                          onKeyUp={ (e)=>{if(e.which === 13 || e.which === 32) this.decState(e, this.decWattRelease)} }
                          onMouseDown={(e)=>{this.decState(e, this.decWatt)}}
                          onMouseUp={(e)=>{this.decState(e, this.decWattRelease)}}
                          onMouseOut={(e)=>{this.decState(e, this.decWattRelease)}}>
                          <img
                            src={(this.state.buttons.wattDownButton)?images.downButtonHover:images.downButton} alt="wattDownButton" />
                        </button>
                        <button
                          onKeyDown={ (e)=>{if(e.which === 13 || e.which === 32) this.incState(e, this.incWatt)} }
                          onKeyUp={ (e)=>{if(e.which === 13 || e.which === 32) this.incState(e, this.incWattRelease)} }
                          onMouseDown={(e)=>{this.incState(e, this.incWatt)}}
                          onMouseUp={(e)=>{this.incState(e, this.incWattRelease)}}
                          onMouseOut={(e)=>{this.incState(e, this.incWattRelease)}}>
                          <img
                            src={(this.state.buttons.wattUpButton)?images.upButtonHover:images.upButton} alt="wattUpButton" />
                        </button>
                      </div>
                      <div className="voltage-control">
                        <button
                          onKeyDown={ (e)=>{if(e.which === 13 || e.which === 32) this.decState(e, this.decVoltage)} }
                          onKeyUp={ (e)=>{if(e.which === 13 || e.which === 32) this.decState(e, this.decVoltageRelease)} }
                          onMouseDown={(e)=>{this.decState(e, this.decVoltage)}}
                          onMouseUp={(e)=>{this.decState(e, this.decVoltageRelease)}}
                          onMouseOut={(e)=>{this.decState(e, this.decVoltageRelease)}}>
                          <img
                            src={(this.state.buttons.voltageDownButton)?images.downButtonHover:images.downButton} alt="voltageDownButton" />
                        </button>
                        <button
                          onKeyDown={ (e)=>{if(e.which === 13 || e.which === 32) this.incState(e, this.incVoltage)} }
                          onKeyUp={ (e)=>{if(e.which === 13 || e.which === 32) this.incState(e, this.incVoltageRelease)} }
                          onMouseDown={(e)=>{this.incState(e, this.incVoltage)}}
                          onMouseUp={(e)=>{this.incState(e, this.incVoltageRelease)}}
                          onMouseOut={(e)=>{this.incState(e, this.incVoltageRelease)}}>
                          <img
                            src={(this.state.buttons.voltageUpButton)?images.upButtonHover:images.upButton} alt="voltageUpButton" />
                        </button>
                      </div>
                      <div className="power-control">
                        <button
                          onKeyDown={ (e)=>{if(e.which === 13 || e.which === 32) this.powerButtonDown()} }
                          onKeyUp={ (e)=>{if(e.which === 13 || e.which === 32) this.powerButtonRelease()} }
                          onMouseDown={this.powerButtonDown}
                          onMouseUp={this.powerButtonRelease}
                          onMouseOut={this.powerButtonRelease}>
                          <img
                            src={(this.state.buttons.powerButton)?images.powerButtonHover:images.powerButton}  alt="powerButton" />
                        </button>
                      </div>
                      <div className="start-control">
                        <button
                          onKeyDown={ (e)=>{if(e.which === 13 || e.which === 32) this.startButtonDown()} }
                          onKeyUp={ (e)=>{if(e.which === 13 || e.which === 32) this.startButtonRelease()} }
                          onMouseDown={this.startButtonDown}
                          onMouseUp={this.startButtonRelease}
                          onMouseOut={this.startButtonRelease}>
                          <img
                            src={(this.state.buttons.startButton)?images.startButtonHover:images.startButton} alt="startButton" />
                        </button>
                        <button
                          onKeyDown={ (e)=>{if(e.which === 13 || e.which === 32) this.stopButtonDown()} }
                          onKeyUp={ (e)=>{if(e.which === 13 || e.which === 32) this.stopButtonRelease()} }
                          onMouseDown={this.stopButtonDown}
                          onMouseUp={this.stopButtonRelease}
                          onMouseOut={this.stopButtonRelease}>
                          <img
                            src={(this.state.buttons.stopButton)?images.stopButtonHover:images.stopButton} alt="stopButton" />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
            </div>
          </div>
        );
    }
}

// const mapStateToProps = (state, ownProps) => {
//   return {
//     id: ownProps.id,
//     voltage: state.powerSupply.voltage,
//     watts: state.powerSupply.watts,
//     current: state.powerSupply.current,
//     timer: state.powerSupply.timer,
//     power: state.powerSupply.power,
//     active: state.powerSupply.active,
//     anodeConnected: state.powerSupply.anodeConnected,
//     cathodeConnected: state.powerSupply.cathodeConnected,
//     results: state.gel.gels[0].results,
//     gelbox: state.gelBox.gelBoxes[0],
//     display: state.modal.display,
//     notebookExpanded: state.scene.notebookExpanded,
//   }
// }

// export default connect(mapStateToProps,{
//     incPowerSupplyTime,
//     decPowerSupplyTime,
//     countDownPowerSupplyTime,
//     resetPowerSupplyTime,
//     incPowerSupplyAmp,
//     decPowerSupplyAmp,
//     incPowerSupplyWatt,
//     decPowerSupplyWatt,
//     incPowerSupplyVoltage,
//     decPowerSupplyVoltage,
//     togglePowerSupplyPower,
//     togglePowerSupplyStart,
//     setGelResults
//   })(PowerSupplyControls);
